import LegalShell from '../../components/legal/LegalShell';

export default function Licensing() {
  return (
    <LegalShell title="Licensing" version="1.1" effective="2026-07-25">
      <p>
        This page summarizes the licensing terms for use of the OculusMind.AI services,
        including the web application and the Agent-to-Agent (A2A) API (collectively, the
        "Services"), operated by Andrew Paris LLC, d/b/a MediaShare-Link. It is
        provided in addition to — not in place of — our{' '}
        <a href="/legal/terms">Terms of Service</a>.
      </p>

      <h2>License to use the Services</h2>
      <p>
        Subject to your continued compliance with our Terms of Service, we grant you a
        limited, non-exclusive, non-transferable, revocable license to access and use the
        Services for your own internal, personal, or commercial purposes, including invoking
        your agents over the A2A API.
      </p>

      <h2>A2A integration tokens</h2>
      <p>
        Tokens issued from the <a href="/integrations">Integrations</a> page are credentials
        bound to your account. You are responsible for keeping them confidential and for all
        activity performed with them. Usage is subject to the same daily limits and
        acceptable-use rules as the web application.
      </p>

      <h2>Restrictions</h2>
      <p>
        You may not resell, sublicense, or redistribute the Services or your access
        credentials; reverse engineer the Services except as permitted by law; or use the
        Services to build a competing offering. Output you generate is yours to use, subject
        to the Terms of Service and applicable third-party model-provider terms.
      </p>

      <h2>Third-party components</h2>
      <p>
        The Services incorporate third-party software and AI models under their respective
        licenses. Nothing here grants you rights to those components beyond what their
        licenses provide.
      </p>
    </LegalShell>
  );
}
